<template>
  <rhcn-drawer
    @on-close="onClose"
    v-loading="loading">
    <div class="drawer-form exchange-form" style="width: 637px;">
      <div>
        <rhcn-step :steps="steps" :active="1"></rhcn-step>
      </div>
      <div>
        <div v-if="contactInfo" class="contact-info-box">
          <p class="contact-info-title">
            {{$t('message.transfer.transferToAct', { payee: contactInfo.bankAccount || '' })}}
          </p>
          <div class="contact-info-desc">
            <p>
              <span v-if="contactInfo.bankCountry" class="margin-right-20">{{getCountryDesc(contactInfo.bankCountry)}}</span>
              <span>{{contactInfo.payoutCurrency}}</span>
            </p>
            <p>{{getCardNumber(contactInfo.cardNumber)}}</p>
          </div>
        </div>
        <el-form ref="formRef1" :model="form" class="form-relactive margin-top-25" :rules="formRules" label-position="top">
          <!-- you send -->
          <rhcn-currency-amount ref="sendRef" :label="$t('message.transfer.youSend')"
            :placeholder="sendAmountPlaceholder"
            input-prop="sendAmount"
            select-prop="sendCurrency"
            :input-value.sync="form.sendAmount"
            :select-value.sync="form.sendCurrency"
            :select-disabled="true"
            :options="sendCurrencyList"
            :option="{currency: 'value', amount: 'amount'}"
            @on-input="inputHandler"
            ></rhcn-currency-amount>
          <div class="rate-wrapper">
            <div class="line"></div>
            <div class="rate-content flex-row">
              <div class="close-icon">
                <span class="el-icon-minus"></span>
              </div>
              <div class="rate-text">
                <span class="rate-amount">{{form.serviceFee}}</span>
                <span class="time">{{$t('message.settlement.serviceAmount')}}</span>
              </div>
            </div>
          </div>
          <!-- beneficiary gets -->
          <rhcn-currency-amount ref="sellRef" :label="$t('message.transfer.beneficiaryGets')"
            input-prop="getAmount"
            select-prop="getCurrency"
            :input-value.sync="form.getAmount"
            :select-value.sync="form.getCurrency"
            :input-disabled="merchantType !== 'B2B'"
            :select-disabled="true"
            :options="getCurrencyList"
            :option="{currency: 'value'}"
            @on-input="inputGetHandler"
            ></rhcn-currency-amount>
          <p class="transfer-tips margin-top-9 margin-bottom-20">{{$t('message.transfer.transferAmountTips')}}</p>
          <template v-if="showPayer">
            <el-checkbox v-model="isPayerChecked" class="margin-bottom-20">
              <span class="payer-check-label">{{$t('message.transfer.designatedPayer')}}</span>
            </el-checkbox>
            <el-form-item v-if="isPayerChecked" prop="payer" :label="$t('message.transfer.payer')">
              <el-select v-model="form.payer" clearable filterable>
                <template v-for="(item, index) in payerList">
                  <el-option :key="index" :value="item.id" :label="`${item.holderName}-${item.accountLabel}`"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </template>
        </el-form>
        <div>
          <validation-component
            ref="formRef2"
            :validation-condition="conditions">
          </validation-component>
        </div>
        <div class="margin-top-30 bottom-box-center" style="padding-bottom: 50px;">
          <el-button :disabled="!validateSubmit()" style="width:100%;" type="primary" @click="submit">{{$t('message.common.next')}}</el-button>
          <p class="btn-previous margin-top-10" @click="handlePrevious">{{$t('message.common.previous')}}</p>
        </div>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

import RhcnDrawer from '@/components/drawer/index.vue';
import RhcnCurrencyAmount from '@/components/form/currency-amount.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import RhcnStep from '@/components/step/index.vue';
import { validateFns, REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { arr2obj } from '@/utils/tools/utils';
import AccountInfo from '@/views/account/information/api/account-info';
import BalancesService from '@/views/settlement/api/settlement-balance';
import {
  getPayeeInfo, getMaterialInfoList, uploadMaterialUseTemplate,
  getCountryGroupListByName,
} from '@/views/transfer/api/contact';
import { PAYMENT_METHOD_OPTIONS } from '@/views/transfer/api/options';
import TransferService from '@/views/transfer/api/transfer';

export default {
  name: 'AmountNormal',
  components: {
    RhcnDrawer,
    RhcnCurrencyAmount,
    RhcnStep,
    ValidationComponent,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  data() {
    return {
      steps: [
        {
          title: 'message.transfer.recipient',
          handler: () => {
            this.$router.push({
              path: '/transfer/transfer/add/recipient',
            });
          },
        },
        {
          title: 'message.exchange.amount',
        },
        {
          title: 'message.exchange.review',
        },
      ],
      formRules: {
        payer: [
          { validator: validateFns([REQUIRED]) },
        ],
        sendAmount: [
          // { validator: validateFns([REQUIRED]) },
          { validator: this.validateSendAmount }, // 余额验证
        ],
      },
      form: {
        payer: '',
        sendCurrency: '',
        getCurrency: '',
        sendAmount: '',
        getAmount: '',
        serviceFee: '',
      },
      sendCurrencyList: [],
      getCurrencyList: [],
      conditions: [
        { // 交易用途
          key: 'transactionPurpose',
          name: 'message.transfer.transactionPurpose',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isHide: true,
          isShowStar: true,
          changeValue: () => {
            this.getMaterialList();
          },
        },
        { // 附言
          key: 'reference',
          name: `${this.$t('message.transfer.payoutPostscri')}`,
          type: 'input',
          defValue: '',
        },
        {
          key: 'fileId',
          name: 'message.transfer.certificate',
          type: 'upload_file',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          isHide: true,
          uploadRange: {
            fileSize: 50, // 50M
            uploadFileList: [],
            uploadTips: this.$t('message.upload.zipOrImgtip'),
            fileUploadFunc: TransferService.uploadCertificateFile,
            fileTypeRule: 'application/zip,application/x-zip-compressed,.zip,application/pdf,image/png,image/jpeg,image/jpg',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: 'PDF, ZIP, PNG, JPEG, JPG' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'PDF, ZIP, PNG, JPEG, JPG' }),
          },
        },
      ],
      cardInfoId: this.$route.query.id,
      contactInfo: null,
      loading: true,
      txnPurposeList: [],
      merchantType: 'COMMON', // B2B COMMON
      showPayer: false,
      payerList: [], // 付款方列表
      isPayerChecked: false,
      sendAmountPlaceholder: '',
      materialTemplates: {}, // 模板资料字典,用于可下载的模板
      materialTemplatesOriginData: [], // 模板资料列表
      materialNameList: [],
      registration: '', // 商户注册地
      exchangeDirection: 0, // 换汇方向 0: 正向  1: 逆向
    };
  },
  async mounted() {
    // 商户类型
    try {
      const userLogin = this.app.userLogin;
      if (userLogin && userLogin.businessType === '0') {
        this.merchantType = 'B2B';
      } else if (userLogin && userLogin.businessType === '2') {
        this.merchantType = 'B2C';
      }
    } catch (error) {
      console.log('get merchant info error in transfer amount', error);
    }
    const accountInfo = await AccountInfo.getAccountInfo();
    this.registration = accountInfo.country;

    let info = {};
    try {
      info = JSON.parse(window.sessionStorage.getItem('transferData'));
    } catch (err) {
      //
    }
    if (info) {
      this.contactInfo = info.contactInfo;
    }
    if (!this.contactInfo) { // 兼容 contactInfo 不存在的问题
      // 收款方详情信息
      await getPayeeInfo({ cardInfoId: this.cardInfoId }).then((res) => {
        this.contactInfo = res;
        // this.getMaterialList();
      }).catch(() => ({}));
    }

    if (this.contactInfo.accountBelong !== '0') { // 自有账户时，不显示付款用途
      this.$refs.formRef2.setItemHide('transactionPurpose', false);
    }
    if (this.contactInfo.accountBelong === '2') { // VAT 缴费
      this.$refs.formRef2.setItemDisabled('transactionPurpose', true);
      this.$refs.formRef2.setItemValue('transactionPurpose', '6');
      this.$refs.formRef2.setItemHide('fileId', false);
      this.conditions[2].name = 'message.contact.vatFile';
      this.conditions[2].uploadRange.fileTypeRuleTips = this.$t('message.supportFileErrorTip', { type: 'PNG, JPEG, JPG' });
      this.conditions[2].uploadRange.uploadTips = this.$t('message.upload.supportFileTip', { type: 'PNG, JPEG, JPG' });
      this.conditions[2].uploadRange.fileTypeRuleTipsShow = this.$t('message.upload.supportFileTip', { type: 'PNG, JPEG, JPG' });
      this.conditions[2].uploadRange.fileTypeRule = 'image/png,image/jpeg,image/jpg';
    }

    // 发起币种
    await BalancesService.getAccountBalances().then((data) => {
      data.forEach((item) => {
        this.sendCurrencyList.push({
          value: item.availBalance.currency,
          amount: item.availBalance.amount,
        });
        this.getCurrencyList.push({
          value: item.availBalance.currency,
        });
        if (this.contactInfo.payoutCurrency === item.availBalance.currency) {
          this.form.sendCurrency = { value: item.availBalance.currency, amount: item.availBalance.amount };
          this.form.getCurrency = { value: item.availBalance.currency };
        }
      });
    }).catch(() => ({}));
    // 付款方列表
    if (this.merchantType === 'B2B') {
      this.showPayer = false;
      // 获取欧洲国家
      const gountryGroupRes = await getCountryGroupListByName({ countryGroupName: 'payment-EU' });
      const euCountryMap = arr2obj(gountryGroupRes.countryGroupInfos || [], { key: 'value' });
      const payoutCurrency = this.contactInfo.payoutCurrency;
      const bankCountry = this.contactInfo.bankCountry;
      if ((payoutCurrency === 'GBP' || payoutCurrency === 'USD' || payoutCurrency === 'EUR') &&
        (!!euCountryMap[bankCountry] || bankCountry === 'GB')) {
        this.showPayer = true;
      }

      if (this.showPayer) {
        await TransferService.getPayerVaList({ filingStatus: 'Y', applyCurrency: this.form.sendCurrency.value }).then((res) => {
          this.payerList = res;
        }).catch(() => ({}));
      }
    }
    // 字典查询
    await GlobalData.getDictList(['TXN_PURPOSE', 'MATERIAL_NAME_URL', 'MATERIAL_NAME', 'COUNTRY']).then((res) => {
      let txnPurposeList = [];
      // 交易用途不显示 【'转至本人账户', '个人汇款'】
      if (res.TXN_PURPOSE) {
        txnPurposeList = res.TXN_PURPOSE.filter((item) => {
          if (['0', '1'].indexOf(item.value) < 0) {
            return item;
          }
        });
      }
      this.txnPurposeList = initSelectedData(txnPurposeList, 'description', 'value', false);
      this.materialNameList = initSelectedData(res.MATERIAL_NAME, 'description', 'value', false);
      this.$refs.formRef2.setValidationSelectOptions('transactionPurpose', this.txnPurposeList);
      if (res.MATERIAL_NAME_URL && res.MATERIAL_NAME_URL.length) {
        for (let i = 0; i < res.MATERIAL_NAME_URL.length; i++) {
          const item = res.MATERIAL_NAME_URL[i];
          this.materialTemplates[item.value] = item.description;
        }
      }

      this.countryList = initSelectedData((res.COUNTRY || []), 'description', 'value', false);
    }).catch(() => ({}));
    // 初始化已填写的数据
    try {
      if (info && info.cardInfoId === this.cardInfoId && info.getCurrency.value === this.form.sendCurrency.value) {
        this.form.payer = info.payer;
        this.form.sendAmount = info.sendAmount;
        this.form.serviceFee = info.serviceFee;
        this.form.getAmount = info.getAmount;
        this.isPayerChecked = (info.isSamePayee === 'Y');
        this.$refs.formRef2.setItemValue('transactionPurpose', info.transactionPurpose);
        this.$refs.formRef2.setItemValue('reference', info.reference);
        if (this.contactInfo.accountBelong !== '0') {
          if (info.materialList && info.materialList.length) {
            this.materialTemplatesOriginData = info.materialList;
            for (let i = 0; i < info.materialList.length; i++) {
              this.addFormItem(info.materialList[i], this.$refs.formRef2, true);
            }
          } else {
            this.$refs.formRef2.setItemValue('fileId', info.fileId);
            this.conditions[2].uploadRange.uploadFileList = info.fileId;
            this.$refs.formRef2.setItemHide('fileId', false);
          }
        }
      } else {
        // 自有账户隐藏交易用途
        if (this.contactInfo.accountBelong === '0') {
          // this.getMaterialList(); // 自有账户不获取材料
        }
      }
    } catch (error) {
      console.log('get old info error', error);
    }
    // if (this.form.sendAmount === '' && this.form.sendCurrency) {
    //   this.sendAmountPlaceholder = this.form.sendCurrency.amount;
    // }
    this.loading = false;

    this.debounceGetFee = _.debounce(this.getFee, 1000);
  },
  methods: {
    onClose() {
      window.sessionStorage.removeItem('transferData');
      this.$router.push({
        path: '/transfer/transfer',
      });
    },
    inputHandler(value) {
      const v = value.match(/^\d*(\.?\d{0,2})/g)[0];
      this.form.sendAmount = v;
      this.$refs.sendRef.inputInnerValue = v;
      this.form.serviceFee = '';
      // 付款金额placeholder
      // if (!isNaN(this.sendAmountPlaceholder) && this.form.sendAmount !== '') {
      //   this.sendAmountPlaceholder = `${this.$t('message.validator.input', { input: this.$t('message.transfer.amount').toLowerCase() })}`;
      // }
      if (!v) {
        return;
      }
      this.debounceGetFee({ isReverse: false, amount: v });
    },
    inputGetHandler(value) {
      const v = value.match(/^\d*(\.?\d{0,2})/g)[0];
      this.form.getAmount = v;
      this.$refs.sellRef.inputInnerValue = v;
      if (!v) {
        return;
      }
      if (+v === 0) {
        return;
      }
      this.debounceGetFee({ isReverse: true, amount: v });
    },
    async getFee({ isReverse = false, amount }) {
      if (!isReverse && (!this.form.sendAmount || (Number(this.form.sendAmount) > Number(this.form.sendCurrency.amount)))) {
        return;
      }
      if (this.contactInfo) {
        // this.loading = true;
        const SUB_PRODUCT_MAP = {
          0: 'WITHDRAW',
          1: 'PAYMENT',
          2: 'VAT_PAYMENT',
        };
        const SubMethod = isReverse ? TransferService.getTransferReverseFee : TransferService.getTransferFee;
        const res = await SubMethod({
          txnAmount: {
            amount,
            currency: this.contactInfo.payoutCurrency,
          },
          subProduct: SUB_PRODUCT_MAP[(+this.contactInfo.accountBelong)], // 收款人所属0,1,2
          paymentMethod: getEnantiomericValue(PAYMENT_METHOD_OPTIONS, this.contactInfo.paymentMethod), // 支付方式 0, 1
          cardBinCountry: this.contactInfo.bankCountry,
        });
        this.form.serviceFee = Math.abs(+res);
        if (isReverse) {
          this.form.sendAmount = this.getMoney(amount, Math.abs(+res));
        } else {
          const ag = this.getMoney(amount, res);
          this.form.getAmount = ag > 0 ? ag : '';
        }
        this.$refs.formRef1.validateField('sendAmount');
        this.exchangeDirection = isReverse ? 1 : 0;
      }
    },
    async submit() {
      try {
        await this.$refs.formRef1.validate();
        this.$refs.formRef2.toFormValid((data) => {
          const submitData = { ...data, ...this.form };
          submitData.cardInfoId = this.cardInfoId;
          submitData.transactionPurposeText = getEnantiomericValue(this.txnPurposeList, submitData.transactionPurpose);
          submitData.merchantType = this.merchantType;
          submitData.payerInfo = null;
          submitData.isSamePayee = 'N';
          if (this.isPayerChecked) {
            submitData.isSamePayee = 'Y';
            for (let i = 0; i < this.payerList.length; i++) {
              if (this.form.payer === this.payerList[i].id) {
                submitData.payerInfo = this.payerList[i];
                break;
              }
            }
          }
          // 模板资料数据
          if (this.materialTemplatesOriginData && this.materialTemplatesOriginData.length) {
            const materialList = [];
            for (let i = 0; i < this.materialTemplatesOriginData.length; i++) {
              const materialTemplatesOriginDataItem = this.materialTemplatesOriginData[i];
              if (materialTemplatesOriginDataItem.materialFormat === '2') {
                materialList.push({
                  ...materialTemplatesOriginDataItem,
                  fileUrl: this.$refs.formRef2.getItemValue(materialTemplatesOriginDataItem.id),
                });
              } else {
                const fileList = this.$refs.formRef2.getValidationItem(materialTemplatesOriginDataItem.id).uploadRange.uploadFileList;
                if (!fileList.length && materialTemplatesOriginDataItem.required) {
                  ShowWarningMessage(this.$t('message.emptyUploadFileTip'));
                  return;
                }
                if (fileList.length) {
                  materialList.push({
                    ...materialTemplatesOriginDataItem,
                    fileUrl: fileList[0].url,
                  });
                } else {
                  materialList.push({
                    ...materialTemplatesOriginDataItem,
                    fileUrl: '',
                  });
                }
              }
              delete submitData[`${materialTemplatesOriginDataItem.id}`];
              delete submitData[`${materialTemplatesOriginDataItem.id}File`];
              delete submitData[`${materialTemplatesOriginDataItem.id}Show`];
            }
            submitData.materialList = materialList;
            submitData.fileId = '';
          }
          delete submitData.fileIdFile;
          delete submitData.fileIdShow;
          submitData.contactInfo = this.contactInfo;
          submitData.exchangeDirection = this.exchangeDirection;
          window.sessionStorage.setItem('transferData', JSON.stringify(submitData));
          this.$router.push({
            path: '/transfer/transfer/add/review',
            query: {
              id: this.$route.query.id,
            },
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    validateSendAmount(rule, value, callback) {
      if (Number(this.form.sendAmount) > Number(this.form.sendCurrency.amount)) {
        callback(new Error(this.$t('message.transfer.insufficientBalance')));
        return;
      }
      if (this.form.sendAmount && Number(this.form.sendAmount) > 0 && Number(this.form.sendAmount) <= Math.abs(Number(this.form.serviceFee))) {
        callback(new Error(this.$t('message.transfer.moreThanFee')));
        return;
      }
      callback();
    },
    getMoney(amount, fee) {
      let r1, r2;
      try { r1 = `${amount}`.split('.')[1].length; } catch (e) { r1 = 0; };
      try { r2 = `${fee}`.split('.')[1].length; } catch (e) { r2 = 0; };
      const m = Math.pow(10, Math.max(r1, r1));
      const n = r1 > r2 ? r1 : r2;
      return ((Number(amount) * m + Number(fee) * m) / m).toFixed(n);
    },
    getMaterialList() {
      const form = this.$refs.formRef2;
      const data = form.getFormJson();
      this.loading = true;
      // 删除原有模板资料列表
      if (this.materialTemplatesOriginData.length) {
        for (let i = 0; i < this.materialTemplatesOriginData.length; i++) {
          form.removeItem(this.materialTemplatesOriginData[i].id);
        }
      }
      const params = {
        businessType: this.app.userLogin.businessType, // 业务类型,0:B2B,1:其它
        payoutTxnType: this.contactInfo.accountBelong === '0' ? 0 : 1, // 出款交易类型,0:提现，1:付款
        entityType: this.contactInfo.entityType, // 主体类型，0:企业；1:个人
        payoutCurrency: this.contactInfo.payoutCurrency, // 出款币种
        txnPurpose: data.transactionPurpose, // 交易用途
        payeeCardInfoId: this.contactInfo.cardInfoId, // payeeCardInfoId参数
      };
      if (`${this.contactInfo.entityType}` === '0') { // 若是企业则加上商户注册地
        params.registration = this.registration;
      }
      getMaterialInfoList(params).then((res) => {
        this.materialTemplatesOriginData = res;
        if (res.length) {
          for (let i = 0; i < res.length; i++) {
            const resItem = res[i];
            const initValue = resItem.materialUnique; // 非唯一材料（例如发票、订单明细等）在下次付款时，不应该带出来。
            this.addFormItem(resItem, form, initValue);
          }
          form.setItemHide('fileId', true);
        } else {
          form.setItemHide('fileId', false);
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    addFormItem(item, form, initValue = true) {
      let defValue = item.materialFormat === '2' ? '' : [];
      if (initValue) { // 使用初始化值
        // materialFormat 【0:附件，1:图片，2:文本】
        if (item.materialFormat === '2' && item.fileUrl) {
          defValue = item.fileUrl;
        } else if (item.fileUrl) {
          defValue = [item.fileUrl];
        }
      }
      const conditionItem = {
        key: item.id,
        name: getEnantiomericValue(this.materialNameList, item.materialName) || item.materialName,
        type: item.materialFormat === '2' ? 'input' : 'upload_file', // 0:附件，1:图片，2:文本
        rule: item.required ? [REQUIRED] : [],
        defValue,
        isShowStar: item.required,
      };
      if (item.materialFormat !== '2') {
        const fileRule = item.materialFormat === '0' ? 'application/zip,application/x-zip-compressed,.zip,application/pdf,image/png,image/jpeg,image/jpg' : 'image/png,image/jpeg,image/jpg';
        const acceptFileTypeExt = item.materialFormat === '0' ? '.png,.jpeg,.jpg,.pdf,.zip' : '.png,.jpeg,.jpg';
        const acceptFileType = item.materialFormat === '0' ? 'png,jpeg,jpg,pdf,zip' : 'png,jpeg,jpg';
        conditionItem.uploadRange = {
          fileSize: 50,
          uploadFileList: (defValue && defValue.length) ? [{
            url: item.fileUrl,
            name: conditionItem.defValue[0].split('/')[conditionItem.defValue[0].split('/').length - 1],
          }] : [],
          uploadTips: this.$t('message.upload.supportFileTip', { type: acceptFileType }),
          fileTypeRule: fileRule,
          fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: acceptFileTypeExt }),
          fileUploadFunc: uploadMaterialUseTemplate,
          status: () => {
            if (item.auditStatus === 'pass' && item.fileUrl) { // 上传资料 存在已审核
              return `<span class="status">${this.$t('message.status.existAuditSuccess')}</span>`;
            } else if (item.auditStatus === 'waiting' && item.fileUrl) { // 上传资料 存在未审核
              return `<span class="status">${this.$t('message.status.existUnAudit')}</span>`;
            } else if (item.auditStatus === 'fail' && item.fileUrl) { // 审核不通过
              return `<span class="status fail">${this.$t('message.status.auditFail')}</span>`;
            }
            return '';
          },
        };
        if (this.materialTemplates[item.materialName]) {
          conditionItem.uploadRange.templateFileName = this.materialTemplates[item.materialName];
          const templateFileArr = this.materialTemplates[item.materialName].split('/');
          conditionItem.uploadRange.templateFileNameShow = `${templateFileArr[templateFileArr.length - 1]}`;
        }
      }
      form.addItem(conditionItem);
    },
    validateSubmit() {
      if (this.merchantType === 'B2B' && this.isPayerChecked && !this.form.payer) {
        return false;
      }
      if (!this.form.sendAmount || !this.form.getAmount || Number(this.form.sendAmount) <= 0 || Number(this.form.getAmount) <= 0) {
        return false;
      }
      const data = this.$refs.formRef2.getFormJson();
      // if (this.contactInfo.accountBelong !== '0' && !data.transactionPurpose) {
      //   return false;
      // }
      for (let i = 0; i < this.conditions.length; i++) {
        const item = this.conditions[i];
        if (!item.isHide && item.isShowStar && !data[item.key]) {
          return false;
        }
      }
      return true;
    },
    handlePrevious() {
      this.$router.go(-1);
    },
    getCountryDesc(code) {
      if (!code) {
        return '';
      }
      return getEnantiomericValue(this.countryList, code);
    },
    getCardNumber(cardNumber) {
      try {
        if (!cardNumber) {
          return '';
        }
        if (cardNumber.indexOf('*') > -1) { // 已打码
          return cardNumber;
        }
        return `${cardNumber.substr(0, 6)}******${cardNumber.substr(-4)}`;
      } catch (err) {
        //
      }
      return cardNumber;
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.exchange-form {
  margin-top: -68px;
}
.contact-info-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 80px;
  border-radius: 2px;
  border: 2px solid #9CBAEC;
  margin-bottom: 20px;
  margin-top: 60px;
  box-sizing: border-box;
  padding-left: 18px;
  padding-right: 20px;
  .contact-info-title {
    font-size: 16px;
    font-weight: bold;
    color: $color-text-primary;
    line-height: 22px;
  }
  .contact-info-desc {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: normal;
    color: $color-text-primary;
    line-height: 32px;
  }
}
.form-relactive {
  .rate-wrapper {
    width: 100%;
    position: relative;
    height: 103px;
    overflow: hidden;
    .line {
      width: 3px;
      height: 103px;
      background: $color-default;
      display: inline-block;
      margin: 0 0 0 22px;
      padding: 0;
      border: 0;
    }
    .rate-content {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      &.flex-row {
        flex-direction: row;
      }
      .close-icon {
        display: inline-block;
        width: 23px;
        height: 23px;
        background: $color-default;
        border-radius: 50%;
        text-align: center;
        line-height: 23px;
        .el-icon-minus {
          line-height: 23px;
          font-weight: bold;
        }
      }
      .rate-text {
        display: flex;
        margin-left: 13px;
        align-items: center;
        .rate-amount {
          font-size: 14px;
          font-weight: bold;
          line-height: 23px;
        }
        .time {
          margin-left: 32px;
          font-size: 14px;
          font-weight: 400;
          line-height: 23px;
        }
      }
    }
  }
  .transfer-tips {
    font-size: 14px;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 20px;
  }
  .payer-check-label {
    color: $color-text-primary;
    font-weight: 800;
  }
}

.bottom-box-center {
  display: flex;
  flex-direction: column;
  align-items: center;

  .btn-previous {
    cursor: pointer;
    color: $color-text-default-button;
    font-weight: 600;
  }
}
</style>
